import {detailServicesPath} from "../../Constants";
import axios from "axios";

export const restUrl = detailServicesPath + '/organization/detail-warehouse'

export default class DetailWarehouseService {
    static async getAll() {
        return axios.get(`${restUrl}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(data) {
        return await axios.post(restUrl, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(warehouseId, newQuantity) {
        return await axios.patch(restUrl + '/' + warehouseId + "?newQuantity=" + newQuantity, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async unableTurn(id, status) {
        return axios.patch(restUrl + '/' + id + '/unable-turn?status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async unableCut(id, status) {
        return axios.patch(restUrl + '/' + id + '/unable-cut?status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}